import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#060B14]">
        <div className="font-mono-data text-[#06B6D4] ai-pulse text-sm tracking-widest">A CARREGAR DAI OS…</div>
      </div>
    );
  if (!user) return <Navigate to="/entrar" replace />;
  return children;
}
